import React, { useState } from 'react';
import MainLayout from './components/Layout/MainLayout';
import LiveFeed from './components/Tabs/LiveFeed';
import IntentLibrary from './components/Tabs/IntentLibrary';
import Analytics from './components/Tabs/Analytics';
import Settings from './components/Tabs/Settings';
import { Toaster } from 'sonner';
export function App() {
  const [activeTab, setActiveTab] = useState('live');
  return <div className="min-h-screen bg-gray-900 text-white" data-id="element-0">
      <Toaster position="top-right" theme="dark" data-id="element-1" />
      <div className="container mx-auto p-4" data-id="element-2">
        {/* Navigation Tabs */}
        <div className="flex mb-6 border-b border-gray-700" data-id="element-3">
          <button className={`px-4 py-2 font-medium ${activeTab === 'live' ? 'text-green-400 border-b-2 border-green-400' : 'text-gray-400'}`} onClick={() => setActiveTab('live')} data-id="element-4">
            Live Feed
          </button>
          <button className={`px-4 py-2 font-medium ${activeTab === 'intent' ? 'text-green-400 border-b-2 border-green-400' : 'text-gray-400'}`} onClick={() => setActiveTab('intent')} data-id="element-5">
            Intent Library
          </button>
          <button className={`px-4 py-2 font-medium ${activeTab === 'analytics' ? 'text-green-400 border-b-2 border-green-400' : 'text-gray-400'}`} onClick={() => setActiveTab('analytics')} data-id="element-6">
            Analytics
          </button>
          <button className={`px-4 py-2 font-medium ${activeTab === 'settings' ? 'text-green-400 border-b-2 border-green-400' : 'text-gray-400'}`} onClick={() => setActiveTab('settings')} data-id="element-7">
            Settings
          </button>
        </div>
        {/* Content based on active tab */}
        <MainLayout data-id="element-8">
          {activeTab === 'live' && <LiveFeed data-id="element-9" />}
          {activeTab === 'intent' && <IntentLibrary data-id="element-10" />}
          {activeTab === 'analytics' && <Analytics data-id="element-11" />}
          {activeTab === 'settings' && <Settings data-id="element-12" />}
        </MainLayout>
      </div>
    </div>;
}